import { ReactElement, cloneElement, isValidElement } from 'react';

import { ObjectAny } from '@/models/types';

export interface RenderElementOptions {
    // NOTE: 'props' (properties) overwrites always
    props?: ObjectAny;
    // NOTE: 'defs' (defaults) overwrites only when there is no defined props
    defs?: ObjectAny;
}

export function renderElement(element: ReactElement, { props, defs }: RenderElementOptions) {
    if (!isValidElement(element)) return element;

    const finalProps = Object.keys(defs ?? {}).reduce((props, key) => {
        if (props[key] !== undefined) return props;
        if ((element?.props as ObjectAny)?.[key] !== undefined) return props;

        props[key] = defs![key];

        return props;
    }, props ?? {});

    // eslint-disable-next-line @eslint-react/no-clone-element
    return cloneElement(element, finalProps);
}
